import * as React from "react";
import styled from "styled-components";
import { DropdownButton, MenuItem } from "components/bootstrap";
import { DEFAULT_PAGE_SIZES } from "hooks/usePaginationQueryParameter";
const StyledDropdownButton = styled(DropdownButton)`
  ~ .dropdown-menu {
    min-width: auto;
  }
`;
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;
const PageSizeSelect = ({
  pageSizes = DEFAULT_PAGE_SIZES,
  pageSize,
  onChange,
  className = "",
  showLabel = true
}) => {
  const select = /* @__PURE__ */ React.createElement(
    StyledDropdownButton,
    {
      className,
      id: "page-size-select",
      title: `${pageSize} Rows`,
      "aria-label": "Configure page size",
      pullRight: true,
      bsSize: "small",
      bsStyle: "default"
    },
    pageSizes.map((size) => /* @__PURE__ */ React.createElement(MenuItem, { key: `option-${size}`, onSelect: () => onChange(size) }, size))
  );
  if (showLabel) {
    return /* @__PURE__ */ React.createElement(Container, { className }, "Show", select);
  }
  return select;
};
export default PageSizeSelect;
